import {Abilities, AbilityBuilder, AbilityOptionsOf, PureAbility} from '@casl/ability';
import {createSelector} from '@reduxjs/toolkit';
import {selectIsUserOnBoard, selectUserIsAuthorizedFlag} from '~/entities/user';

export type PageAction = 'view';
export type PageType = 'public' | 'auth' | 'kyc' | 'preview' | 'feature';
export type ApiAction = 'fetch-from';
export type ApiType = 'private-api';

type UserAction = PageAction | 'manage';
type AppSubject = PageType | 'all';
export type AbilitySentence = [UserAction, AppSubject] | [ApiAction, ApiType];

export default createSelector(selectIsUserOnBoard, selectUserIsAuthorizedFlag, (userIsOnBoard, userIsAuthorized) =>
    buildAbility<AbilitySentence>(allow => {
        allow('view', 'public');
        if (!userIsAuthorized) {
            allow('view', 'auth');
            return;
        }
        allow('view', 'preview');
        allow('fetch-from', 'private-api');
        if (userIsOnBoard) {
            allow('view', 'feature');
        } else {
            allow('view', 'kyc');
        }
    })
);

const buildAbility = <A extends Abilities, C = unknown>(
    scope: (can: AbilityBuilder<PureAbility<A, C>>['can'], cannot: AbilityBuilder<PureAbility<A, C>>['cannot']) => void,
    options?: AbilityOptionsOf<PureAbility<A, C>>
) => {
    const {can, cannot, build} = new AbilityBuilder(PureAbility<A, C>);
    scope(can, cannot);
    return build(options);
};
